import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Badge } from '@criteria-labs/react';
import { SchemaEnumValues } from './SchemaEnumValues';
import { Markdown } from '../../markdown';
import { Link } from '../../markdown/src/Link';
import { Paragraph } from '../../markdown/src/Paragraph';
export function SchemaOverviewSection({ schema }) {
    if (typeof schema === 'boolean') {
        return null;
    }
    const { title, description, deprecated, externalDocs } = schema;
    if ('$schema' in schema) {
    }
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "my-3 py-2", children: _jsxs("h1", { className: "flex items-center text-2xl font-normal leading-6 text-zinc-950 dark:text-white", children: [_jsx("span", { children: title }), '$schema' in schema && (_jsx(Badge, { color: "zinc", className: "ml-2", children: "JSON Schema" })), deprecated && (_jsx(Badge, { color: "orange", className: "ml-2", children: "Deprecated" }))] }) }), _jsxs("div", { className: "pb-3 text-xs text-zinc-700 dark:text-zinc-300", children: [_jsx(Markdown, { content: description }), _jsx(SchemaEnumValues, { schema: schema }), externalDocs && (_jsx(Paragraph, { children: _jsx(Link, { href: externalDocs.url, children: externalDocs.description }) }))] })] }));
}
